export default __webpack_public_path__ + "YWP-dark.svg";